import {
    PAYROLL_CALCULATE_BULLETIN_FAIL,
    PAYROLL_CALCULATE_BULLETIN_REQUEST,
    PAYROLL_CALCULATE_BULLETIN_SUCCESS,
    PAYROLL_CLEAR_ERROR,
    PAYROLL_DELETE_RESOURCE_FAIL,
    PAYROLL_DELETE_RESOURCE_REQUEST,
    PAYROLL_DELETE_RESOURCE_SUCCESS,
    PAYROLL_FETCH_BULLETIN_LINES_FAIL,
    PAYROLL_FETCH_BULLETIN_LINES_REQUEST,
    PAYROLL_FETCH_BULLETIN_LINES_SUCCESS,
    PAYROLL_FETCH_RESOURCE_FAIL,
    PAYROLL_FETCH_RESOURCE_REQUEST,
    PAYROLL_FETCH_RESOURCE_SUCCESS,
    PAYROLL_SAVE_RESOURCE_FAIL,
    PAYROLL_SAVE_RESOURCE_REQUEST,
    PAYROLL_SAVE_RESOURCE_SUCCESS,
} from "../actions/payrollActions";

const collectionKeys = [
    "exercicesPaie",
    "periodes",
    "historiqueSalaires",
    "salaires",
    "rubriques",
    "tauxCotisations",
    "baremesIr",
    "baremesFraisProfessionnels",
    "typesHeuresSupplementaires",
    "situationsCnss",
    "elementsVariables",
    "bulletins",
    "remunerations",
    "parametragesPrimes",
    "profilsCimr",
    "cimrConfiguration",
];

const emptyCollections = collectionKeys.reduce((acc, key) => ({ ...acc, [key]: [] }), {});

const initialState = {
    loading: false,
    saving: false,
    calculating: false,
    error: null,
    selectedBulletin: null,
    bulletinLines: [],
    ...emptyCollections,
};

const upsert = (items, item) => {
    const exists = items.some((row) => row.id === item.id);
    if (!exists) return [item, ...items];
    return items.map((row) => (row.id === item.id ? item : row));
};

export default function payrollReducer(state = initialState, action) {
    switch (action.type) {
        case PAYROLL_FETCH_RESOURCE_REQUEST:
            return { ...state, loading: true, error: null };

        case PAYROLL_FETCH_RESOURCE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                [action.payload.resource]: action.payload.data || [],
            };

        case PAYROLL_FETCH_RESOURCE_FAIL:
            return { ...state, loading: false, error: action.payload.error };

        case PAYROLL_SAVE_RESOURCE_REQUEST:
        case PAYROLL_DELETE_RESOURCE_REQUEST:
            return { ...state, saving: true, error: null };

        case PAYROLL_SAVE_RESOURCE_SUCCESS:
            return {
                ...state,
                saving: false,
                [action.payload.resource]: upsert(state[action.payload.resource] || [], action.payload.data),
            };

        case PAYROLL_DELETE_RESOURCE_SUCCESS:
            return {
                ...state,
                saving: false,
                [action.payload.resource]: (state[action.payload.resource] || []).filter((row) => row.id !== action.payload.id),
            };

        case PAYROLL_SAVE_RESOURCE_FAIL:
        case PAYROLL_DELETE_RESOURCE_FAIL:
            return { ...state, saving: false, error: action.payload.error };

        case PAYROLL_CALCULATE_BULLETIN_REQUEST:
            return { ...state, calculating: true, error: null };

        case PAYROLL_CALCULATE_BULLETIN_SUCCESS:
            return {
                ...state,
                calculating: false,
                selectedBulletin: action.payload,
                bulletins: upsert(state.bulletins || [], action.payload),
            };

        case PAYROLL_CALCULATE_BULLETIN_FAIL:
            return { ...state, calculating: false, error: action.payload };

        case PAYROLL_FETCH_BULLETIN_LINES_REQUEST:
            return { ...state, loading: true, error: null };

        case PAYROLL_FETCH_BULLETIN_LINES_SUCCESS:
            return { ...state, loading: false, bulletinLines: action.payload.data || [] };

        case PAYROLL_FETCH_BULLETIN_LINES_FAIL:
            return { ...state, loading: false, error: action.payload };

        case PAYROLL_CLEAR_ERROR:
            return { ...state, error: null };

        default:
            return state;
    }
}
